import { endOfMonth, startOfMonth } from '@sequencehq/utils/dates'
import { toApiDateTime } from 'CreditNotes/utils/toApiDateTime.ts'

export function getDefaultCreditNoteBillingPeriod(): {
  billingPeriodStart: string
  billingPeriodEnd: string
} {
  const now = new Date()

  return {
    billingPeriodStart: toApiDateTime(startOfMonth(now)),
    billingPeriodEnd: toApiDateTime(endOfMonth(now))
  }
}
